import React, { Component } from "react";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import KurdishSoraniNumbersToWords from "kurdish-numbers-to-words/Sorani.js";
import "../AllPrint.css";
class RentPrintKurdish extends Component {
 render() {
  const {
   lang,
   change_Lang,
   rent_invoice_obj,
   user,
   thirdcolor,
   primary_logo,
   index_rentcontrct,
   footer_logo,
   name_krd,
  } = this.props;
  // Kurdish
  let numberWordsSorani1 =
   rent_invoice_obj.introduction !== undefined &&
   rent_invoice_obj.introduction !== null
    ? KurdishSoraniNumbersToWords.convert(
       parseFloat(rent_invoice_obj.introduction.toString().replace(/,/g, ""))
      )
    : 0;
  let numberWordsSorani2 =
   rent_invoice_obj.paymentmonth !== undefined &&
   rent_invoice_obj.paymentmonth !== null
    ? KurdishSoraniNumbersToWords.convert(
       parseFloat(rent_invoice_obj.paymentmonth.toString().replace(/,/g, ""))
      )
    : 0;
  let numberWordsSorani3 =
   rent_invoice_obj.feelate !== undefined && rent_invoice_obj.feelate !== null
    ? KurdishSoraniNumbersToWords.convert(
       parseFloat(rent_invoice_obj.feelate.toString().replace(/,/g, ""))
      )
    : 0;
  let numberWordsSorani4 =
   rent_invoice_obj.safly !== undefined && rent_invoice_obj.safly !== null
    ? KurdishSoraniNumbersToWords.convert(
       parseFloat(rent_invoice_obj.safly.toString().replace(/,/g, ""))
      )
    : 0;
  let numberWordsSorani5 =
   rent_invoice_obj.MonthForRent !== undefined &&
   rent_invoice_obj.MonthForRent !== null
    ? KurdishSoraniNumbersToWords.convert(Number(rent_invoice_obj.MonthForRent))
    : 0;
  return (
   <>
    <div className="fkr">
     <div className="conn">
      <div class="row " style={{ marginTop: 310 }}>
       <div class="col-4">
        <p
         style={{
          fontSize: "24px",
          color: "#000",
          textAlign: "right",
          fontWeight: "bold",
         }}
         class=" text-uppercase"
        >
         &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
         <Time
          value={rent_invoice_obj.createdAt}
          format="YYYY-MM-DD"
          style={{
           fontSize: "24px",
           color: "#000",
           fontWeight: "bold",
          }}
         />
        </p>
       </div>
       <div class="col-4 d-flex justify-content-center">
        <p
         style={{
          fontSize: "30px",
          color: "#000",
          fontWeight: "bolder",
          position: "absolute",
          top: -70,
          width: "100%",
         }}
         class={`d-flex justify-content-center text-uppercase ${
          lang !== "en" ? "fkr" : "fkp"
         } `}
        >
         ({change_Lang("Rental contract")})
        </p>
       </div>
       <div class="col-4 text-right">
        <p
         style={{
          fontSize: "24px",
          color: "#000",
          fontWeight: "bold",
         }}
         class=" text-uppercase"
        >
         {change_Lang("contract number")} #&nbsp;
         {index_rentcontrct}&nbsp;
        </p>
       </div>
      </div>
      <div class="row">
       <div class="col-12">
        <div class="form-group row form-inline">
         <label
          style={{
           fontSize: "25px",
           color: "#000",
           fontWeight: "bolder",
          }}
          class="col-sm-3 col-form-label d-flex justify-content-start fkk"
         >
          لایەنی یەکەم (خاوەن):
         </label>
         <div class="col-sm-3">
          <label
           class="d-flex justify-content-start"
           style={{
            fontWeight: "bold",
            fontSize: "22px",
            color: "#000",
           }}
          >
           {rent_invoice_obj.firstname}
          </label>
         </div>
         <label
          style={{
           fontSize: "25px",
           color: "#000",
           fontWeight: "bold",
          }}
          class="col-sm-3 col-form-label fkk d-flex justify-content-start"
         >
          لايەنى دووەم (کرێچی):
         </label>
         <div class="col-sm-3">
          <label
           class="d-flex justify-content-start"
           style={{
            fontWeight: "bold",
            fontSize: "22px",
            color: "#000",
           }}
          >
           {rent_invoice_obj.tenantId && rent_invoice_obj.tenantId.secondname}
          </label>
         </div>
         {/* phone */}
         {/* <label
                        style={{
                          fontSize: "23px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                        class="col-sm-3 col-form-label fkk d-flex justify-content-start"
                      >
                        ژمارەی مۆبایل:
                      </label>
                      <div class="col-sm-3">
                        <label
                          class="d-flex justify-content-start"
                          style={{ fontWeight: "bold", fontSize: "18px" }}
                        >
                          {rent_invoice_obj.phone1}
                        </label>
                      </div>
                      <label
                        style={{
                          fontSize: "23px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                        class="col-sm-3 col-form-label fkk d-flex justify-content-start"
                      >
                        ژمارەی مۆبایل:
                      </label>
                      <div class="col-sm-3">
                        <label
                          class="d-flex justify-content-start"
                          style={{ fontWeight: "bold", fontSize: "18px" }}
                        >
                          {rent_invoice_obj.tenantId &&
                            rent_invoice_obj.tenantId.phone2}
                        </label>
                      </div> */}
         <label
          style={{
           fontSize: "25px",
           color: "#000",
           fontWeight: "bold",
          }}
          class="col-sm-3 col-form-label fkk d-flex justify-content-start"
         >
          {" "}
          {change_Lang("first_rule_place")}:
         </label>
         <br />
         <div class="col-sm-3">
          <label
           class="d-flex justify-content-start"
           style={{
            fontWeight: "bold",
            fontSize: "22px",
            color: "#000",
           }}
          >
           {rent_invoice_obj.available_id &&
            rent_invoice_obj.available_id.Place_ku}
          </label>
         </div>

         <label
          style={{
           fontSize: "25px",
           color: "#000",
           fontWeight: "bold",
          }}
          class="col-sm-3 col-form-label fkk d-flex justify-content-start"
         >
          {change_Lang("Type of property")}:
         </label>
         <div class="col-sm-3">
          <label
           class="d-flex justify-content-start"
           style={{
            fontWeight: "bold",
            fontSize: "22px",
            color: "#000",
           }}
          >
           {change_Lang(
            rent_invoice_obj.available_id &&
             rent_invoice_obj.available_id.Property
           )}
          </label>
         </div>
         {/* Area */}
         <label
          style={{
           fontSize: "25px",
           color: "#000",
           fontWeight: "bold",
          }}
          class="col-sm-3 col-form-label fkk d-flex justify-content-start"
         >
          {rent_invoice_obj.available_id &&
          rent_invoice_obj.available_id.Property !== "Apartment"
           ? change_Lang("Number of property")
           : change_Lang("NumberOfShuqa")}
          :
         </label>

         <div class="col-sm-3">
          <label
           class="d-flex justify-content-start"
           style={{
            fontWeight: "bold",
            fontSize: "22px",
            color: "#000",
           }}
          >
           {rent_invoice_obj.available_id &&
            rent_invoice_obj.available_id.NOoFProperty}
          </label>
         </div>

         <label
          style={{
           fontSize: "25px",
           color: "#000",
           fontWeight: "bold",
          }}
          class="col-sm-3 col-form-label fkk d-flex justify-content-start"
         >
          {change_Lang("Area")}:
         </label>
         <div class="col-sm-3">
          <label
           class="d-flex justify-content-start"
           style={{
            fontWeight: "bold",
            fontSize: "22px",
            color: "#000",
           }}
          >
           {rent_invoice_obj.available_id && rent_invoice_obj.available_id.Area}
           &nbsp;م<sup>2</sup>
          </label>
         </div>
        </div>

        <p
         style={{
          fontSize: "22px",
          color: "#2d5e69",
          fontWeight: "bolder",
          borderRadius: "50px 0px 0px 0px",
         }}
         id="liniar"
         class="my-0 d-flex justify-content-center fk"
        >
         {change_Lang("agreement")}
        </p>
       </div>
      </div>
      <div className="row">
       <div className="col-12">
        <table className="table">
         <tbody>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
           className="p-0 m-0"
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            1-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "20px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            ﻻﯾﻪﻧﯽ ﯾﻪﮐﻪم ڕەزاﻣﻪﻧﺪە ﻟﻪﺳﻪر بەکرێدانی ﺋﻪم موڵکەی ﮐﻪ ﻟﻪ ﺳﻪرەوە
            ﺋﺎﻣﺎژەی پێکراو ﺑﻪ ﻻﯾﻪﻧﯽ دووەم.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
            lineHeight: "0px",
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            2-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "20px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            ﻣﺎوەی ﺋﻪم گرێبەستە (
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             value={rent_invoice_obj.rental}
             style={{}}
             className="text-center"
            />
            ) ﻣﺎﻧﮕﻪ دەستپێدەکات ﻟﻪ ﺑﻪرواری (
            <Time
             value={rent_invoice_obj.startdate}
             format="YYYY-MM-DD"
             style={{
              color: "black",
             }}
            />
            ) ﺗﺎ (
            <Time
             value={rent_invoice_obj.enddate}
             format="YYYY-MM-DD"
             style={{
              color: "black",
             }}
            />
            ) وە ﻟﻪﮐﺎﺗﯽ کۆتایی هاتنی ﻣﺎوەی ئاماژەپێکراو ﻟﻪﺳﻪر ﻻﯾﻪﻧﯽ دووەﻣﻪ ﮐﻪ
            شوێنی بەکرێگیراو چۆڵ ﺑﮑﺎت بێ ﺋﻪوەی پێویستی ﺑﻪ ﺋﺎﮔﺎدار ﮐﺮدﻧﻪوە هەبێت.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            3-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "19px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            هەردوو ﻻﯾﻪن رەزاﻣﻪﻧﺪن ﻟﻪﺳﻪر کرێی ﻣﺎﻧﮕﺎﻧﻪ ﺑﻪ بڕی (
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             value={rent_invoice_obj.paymentmonth}
             style={{}}
             className="text-center"
             prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
            />
            ) &nbsp;
            {numberWordsSorani2}
            {lang === "en" && rent_invoice_obj.currency === "dolar"
             ? "($)"
             : lang === "krd" && rent_invoice_obj.currency === "dolar"
             ? "(دۆلاری ئەمریکی)"
             : lang === "arb" && rent_invoice_obj.currency === "dolar"
             ? "(دولار)"
             : lang === "en" && rent_invoice_obj.currency !== "dolar"
             ? "(ID)"
             : lang === "krd" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : lang === "arb" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : ""}
            .
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            4-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "19px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            ﻻﯾﻪﻧﯽ دووەم بڕی (
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             value={rent_invoice_obj.introduction}
             style={{}}
             prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
             className="text-center"
            />
            ) &nbsp;
            {numberWordsSorani1}
            {lang === "en" && rent_invoice_obj.currency === "dolar"
             ? "($)"
             : lang === "krd" && rent_invoice_obj.currency === "dolar"
             ? "(دۆلاری ئەمریکی)"
             : lang === "arb" && rent_invoice_obj.currency === "dolar"
             ? "(دولار)"
             : lang === "en" && rent_invoice_obj.currency !== "dolar"
             ? "(ID)"
             : lang === "krd" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : lang === "arb" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : ""}{" "}
            دەدات ﺑﻪ ﻻﯾﻪﻧﯽ ﯾﻪﮐﻪم وەک پێشەکی (
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             value={rent_invoice_obj.Monthintroduction}
             className="text-center"
            />
            ) ﻣﺎﻧﮓ .
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            5-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "19px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            دوای پێشەﮐﯽ ﮐﺮێیکە ﺑﻪم شێوەیە دەدرێت: (
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             value={rent_invoice_obj.MonthForRent}
             className="text-center"
            />
            ) ﻣﺎﻧﮓ- ({numberWordsSorani5} مانگ) .
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            6-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "19px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            ﻻﯾﻪﻧﯽ دووەم ﭘﺎﺑﻪﻧﺪ دەبێت ﺑﻪ پێداﻧﯽ بڕی (
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             style={{}}
             value={rent_invoice_obj.safly}
             className="text-center"
             prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
            />
            ) &nbsp;
            {numberWordsSorani4}
            {lang === "en" && rent_invoice_obj.currency === "dolar"
             ? "($)"
             : lang === "krd" && rent_invoice_obj.currency === "dolar"
             ? "(دۆلاری ئەمریکی)"
             : lang === "arb" && rent_invoice_obj.currency === "dolar"
             ? "(دولار)"
             : lang === "en" && rent_invoice_obj.currency !== "dolar"
             ? "(ID)"
             : lang === "krd" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : lang === "arb" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : ""}
            ( وەک دڵنیایی)ﺗﺄﻣﯿﻨﺎت ﺑﻪ {name_krd} وە ﺋﻪم بڕە پارەیە دەگەرێندرێتەوە
            بۆ لایەنی دووەم بە پسولەی تأمینات دوای کۆتای هاتنی ماوەی گرێبەست بە
            مەرجێك لایەنی دووەم مۆڵکەکە بەبێ بوونی هیچ کەم و کوڕیەک
            رادەستکاتەوە.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            7-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "19px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            لایەنی دووەم ئەم موڵکە بە کار دێنێت بۆ مەبەستی{" "}
            {change_Lang(rent_invoice_obj.perpose)
             ? change_Lang(rent_invoice_obj.perpose)
             : rent_invoice_obj.perpose}{" "}
            لە کاتی بەکارهێنانی بۆ هەر مەبەستێکی تر پێویستە ئاگاداری {name_krd}
            بکات و ڕەزامەندی لایەنی یەکەم بە نووسراو وەربگرێت. بە پێچەوانەوەو
            مافی لایەنی یەکەمە ئەم گرێبەستە هەڵبوشێنێتەوە بەبێ ئاگاداری لایەنی
            دووەم.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            8-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "19px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            لایەنی دووەم بەڵێن دەدات کە پارێزگاری لە شوێنی بەکرێگیراو بکات لە
            کاتی سوود وەرگرتن لە شوێنێکە وە دووری بگرێت لە تێکچوون و داڕمان وە
            بەکارنەهێنانی بەشێوەیەکی نەخوازراو.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fk" : "fkp"}`}
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",

             fontSize: "19px",
            }}
            scope="row"
           >
            9-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "19px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            لایەنی دووەم بۆی نیە شوێنی بەکرێگیراو بەکاربهێنێت یاخود داوای کلیلی
            موڵکەکەت بکات بۆ هەرمەبەستێک بێت تا ڕێپێدانی ئاسایش یاخوود لایەنی
            پەیوەندیدار وەردەگرێت. بەپێچەوانەوە بەرپرسیار دەبێت بەرامبەر یاسا.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            10-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "19px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            لایەنی دووەم ڕایدەگەیێنێت کە شوێنی بەکرێگیراو بەچاوی خۆی بەتاوەوەتی
            سەیری کردووە بە شێوازێک کە (جێی نکوڵی کردن نیە-نافیە للجاهلە) وە
            رەزامەندی بووە پێی وە پابەند دەبێت بە بەکرێدانەوەی یان وازهێنانی یان
            هێنانەوەی هاوبەشێک لەگەڵ خۆی بەتەواوەتی یان بەشێک بۆ هەرکەسێکی تر.
           </td>
          </tr>
         </tbody>
        </table>
       </div>
      </div>
     </div>
     <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br />
     <br />
     <br />
     <br />
     <div className="conn">
      <div className="row">
       <div className="col-12">
        <table className="table">
         <tbody>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            11-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            پێویستە لایەنی دووەم پێش بەکارهێنانی شوێنی بەکرێگیراوە لەسەر ئەستۆی
            خۆی گشت قۆفلی دەرگا دەرەکیەکان بگۆڕێت. بەپێچەوانەوە لەڕوودانی
            هەرکێشەیەک تەنیا خۆی بەرپرسیار دەبێت.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            12-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            لایەنی دووەم پابەند دەبێ بە پیدانی کرێ لە رێکەوتی دیاریکراو لەم
            گرێبەستە. وە ئەگەر (7) حەوت رۆژ لە وادەی دیاریکراوە دواکەوت ئەوا
            لایەنی دووەم بەرپرسیار دەبێت بەرامبەر بە یاسا بە پیی بەندی (38) لەم
            گرێبەستە.
           </td>
          </tr>

          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            13-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            دوای تەواوبوونی ماوەی ئەم گرێبەستە ئەگەر لایەنی دووەم پابەند نەبێ بۆ
            چۆڵکردن یان نوێکردنەوەی ئەم گرێبەسەتە ئەوا کریی مۆڵکەکە دەبێت بە
            رۆژانەی بە بڕی (
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             style={{}}
             value={rent_invoice_obj.feelate}
             className="text-center"
             prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
            />
            ) (&nbsp;
            {numberWordsSorani3}&nbsp;
            {lang === "en" && rent_invoice_obj.currency === "dolar"
             ? "($)"
             : lang === "krd" && rent_invoice_obj.currency === "dolar"
             ? "دۆلاری ئەمریکی"
             : lang === "arb" && rent_invoice_obj.currency === "dolar"
             ? "(دولار)"
             : lang === "en" && rent_invoice_obj.currency !== "dolar"
             ? "(ID)"
             : lang === "krd" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : lang === "arb" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : ""}
            ) بۆ هەر ڕۆژێک هەژمار دەکرێت تا ئەوکاتەی یەکلایی دەبێتەوە.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            14-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            لەبەرواوری واژوو کردنی ئەم گرێبەستە خزمەتگزاریەکانی پرۆژە و شارەوانی
            و کارەبا ئاو و هەر خزمەتگوزاریەکی تر هەبێت لە ئەستۆی لایەنی دووەمە.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            15-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            ئەگەر لایەنی دووەم نیازی هەبێت هەرجۆرە گۆرانکاریەک بکات لە دەرەوە
            یان ناوەوەی ئەم موڵکە بکات پێویستە بە ئاگاداری {name_krd} و
            بەرەزامەندی نووسراوی لایەنی یەکەم بێت وە پیویستە گۆرانکاریەکان دیاری
            بکریت.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            16-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            لایەنی دووەم بە هیچ شیوەیەک بۆی نیە ئەم موڵکە (گشتی یان بەشیکی)
            بەکری بداتەوە بە لایەنێکی تر بەبێ ئاگادارکردنەوەی {name_krd}
            هەروەها بەبێ وەرگرتنی رەزامەندی نووسراوی لایەنی یەکەم.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            17-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            ئەگەر لەماوەی ئەم گرێبەستە خاوەنداریەتی ئەم ئەم موڵکە گوازراوە بۆ
            هەر لایەنەکی تر بە هەر هۆیەک بێت ئەوا لایەنی دووەم بۆی هەیە لە ناو
            موڵکەکە بمینێتەوە تا کۆتایی هاتنی ماوەی گرێبەستەکە وە خاوەنە نوێکەش
            پابەند دەبێت بە ناوەڕۆکی ئەم گرێبەستە.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            18-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            ئەگەر لایەنی دووەم پێش کۆتایی هاتنی گرێبەستە شوێنی بەکری گیراوی چۆڵ
            کرد ئەوا {name_krd} بەپێ توانا بۆ گێرانەوەی (بەشێک یان گشت) کرێی
            ماوی چۆڵکردنی موڵکەکە بە مەرجێک ئەگەر موڵکەکە لەلایەن {name_krd}
            بەکرێدرایەوە.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            19-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            {name_krd} هاوکار دەبێت ( نەک بەپرس ) لە نێوان هەردوولایەن لە ماوەی
            کارابونی ئەم گرێبەستە بۆ بەردەوام بوون چارەسەرکردنی کێشە ئەگەر
            هەبوو.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            20-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            ئەگەر شوێنی بەکرێگیراو راخراو بوو (مؤثث) ئەوا لەسەر هەردوو لایەن
            پێویستە کەل و پەلەکان ئەژمار بکەن (جرد) وە وێنەی بگرن وە هاوپێچی ئەم
            گرێبەستە بکەن بۆ بەرچاو روونی هەردوولایەن.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            21-
           </th>
           <td
            style={{
             lineHeight: "1.1",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            ئەگەر شوێنی بەکرێگیراو راخراو بوو ( مؤثث) لایەنی دووەم پێویستە
            پارێزکاری بکات لە کەلو پەلەکانی لەکاتی چۆڵکردنی شوێنی بەکرێگیراو وەک
            خۆی ڕادەستی لایەنی یەکەم بکاتەوە بەپێچەوانەوە لایەنی دووەم بەرپرسە
            لە چاکردنی گۆڕینی لەسەر ئەرکی خۆی.
           </td>
          </tr>
         </tbody>
        </table>
       </div>
      </div>
     </div>
     <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br />
     <br />
     <br />
     <br />
     <div className="conn">
      <div className="row">
       <div className="col-12">
        <table className="table">
         <tbody>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            22-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            لایەنی یەکەم بەرپرسە لە پێدانی پارەی کارەبای حکومی و تایبەت ( ئەهلی)
            خزمەتگوزاریەکانی و ئەستۆ پاکی بکات پێش بەکرێدانی و واژووکردنی ئەم
            گرێبەستە.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            23-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            لایەنی یەکەم بەرپرسە لە چاکردنەوەی هەر کەم وکوڕیەک کە پەیوەندی بە
            ژێرخانی و موڵکەکە هەبێت وەک (تقینی دیاور یان کاشی ،خواربوونی پی ڤی
            سی ،گیرانی زێراب و دڵۆپەکان ، تەقینی بۆری ئاو ، شێ(رطبة) ،سووتانی
            سبلیت یا روودانی کارەساتی سرووشتی......).
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            24-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            لایەنی یەکەم دڵنیای ئەوە دەکاتەوە کە ( ئامادەی ڕووبەرووبوونەوەی
            یاسیاییە-التعرض القانونی) لە هەرکەسێک دەربارەی شوێنی بەکرێگیراوە بە
            پێچەوانەوە مافی لایەنی دووەمە کە لە پێدانی کرێ بوەستێت سەرەرای بوونی
            مافی هەڵوەشاندنەوەی گرێبەستەکە.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            25-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            هەردوولایەن ڕێککەوتوون کە باجی خانووبەرە لەلایەن یەکەمەوە دەدرێت بە
            پێی یاسای باجی خانوو بەرە کارپێکراوە.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            26-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            لە کاتی ئامادەبوونی کرێ وە ئاگادارکردنەوەی لایەنی یەکەم بۆ وەرگرتنی
            پێویستە لایەنی یەکەم بە زووترین کات ئامادەبێت لە {name_krd}&nbsp; وە
            کرێکەی وەرگرێت بە پێچەوانەوە پارەکە دەخرێتە سەرئاژماری (حیساب) بانکی{" "}
            {name_krd} دوای بە چەک بۆی خەرج دەکرێت.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            27-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            هەردوو لایەن ڕێکەووتوون ئەم گرێبەستە کارا دەبێت و جێبەجێ دەکات
            دەکرێت لە حاڵەتی گیانلەدەستانی لایەنی یەکەم خوانەکردە ئەمەش بۆ
            گفتووگۆ لەگەڵ ماوەکانی لایەنی یەکەم بە هەمان ئەو مەرج و حکومانەی لە
            کاتی واژوو کردنی ئەم گرێبەستە بوونیان هەبووە وە هەروەها لەکاتی
            گواستنەوەی خاوەنداریەتی شوێنی بەکرێگیراو بەتەواوەتی یان بەشێکی بۆ
            هەرکەسێکی تر جا بەهەرهۆیەک بێت.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            28-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            هەریەک لە لایەنی یەکەم و دووەم پێویستە بڕی کرێێ نیو مانگ بۆ هەر
            ساڵێک بدەن بە {name_krd} لە بڕی ڕێکخستنی ئەم گرێبەستە.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            29-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            لایەنی دووەم پێویستە (مانگیک) پێش کۆتایی هاتنی ئەم گرێبەستە ،
            ئاگاداری {name_krd} بکات بەوەی ئەگەر نیازی هەبێت نوێکردنەوە یاخود
            چۆڵکردنی شوێنی بە کرێ گیراو ، بە پێچەوانەوە کرێێ (مانگێک) دەکەوێت
            ەئەستۆی لایەنی دووەم.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            30-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            ﻟﻪﮐﺎﺗﯽ چۆڵکردن ﺷﻮێنی ﺑﻪکرێگیرﺮاو ﻮپێویستە ﻻﯾﻪﻧﯽ دووەم چۆن ﻣﻮڵکەﮐﻪی
            وەرﮔﺮﺗﻮوە وەک خۆی بێ ﮐﻪم و ﮐﻮری رادەﺳﺘﯽ ﻻﯾﻪﻧﯽ ﯾﻪﮐﻪم ﺑﮑﺎﺗﻪوە ، ﺑﻪ
            ﭘێچەواﻧﻪوە ﺑﻪرﭘﺮﺳﻪ ﻟﻪ ﭼﺎﮐﮑﺮدﻧﻪوەی ﮐﻪم و ﮐﻮڕﯾﻪﮐﺎن ﺑﻪ زووﺗﺮﯾﻦ ﮐﺎت.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            31-
           </th>
           <td
            style={{
             lineHeight: "1.2",
             wordSpacing: "0px",
             color: "#000",

             fontSize: "22px",
             textAlign: "justify",
             borderTop: "none",
            }}
           >
            ﻻﯾﻪﻧﯽ دووەم ﭘﺎﺑﻪﻧﺪە ﺑﻪ ﭘێداﻧﯽ ﭘﺎرەی ﺋﺎو و ﮐﺎرەﺑﺎی ﻧﯿﺸﺘﯿﻤﺎﻧﯽ ﻟﻪﮔﻪڵ
            ﻫﺎﺗﻨﯽ ﭘﺴﻮوﻟﻪ وە پێویستە ﻟﻪ ﮐﺎﺗﯽ چۆڵ ﮐﺮدن شوێنی ﺑﻪکرێگیراو ﺳﻪرداﻧﯽ
            ﻓﻪرﻣﺎﻧﮕﻪی ﺋﺎو و ﮐﺎرەﺑﺎی ﻧﯿﺸﺘﯿﻤﺎﻧﯽ ﺑﮑﺎت ﺑۆ ﭘێداﻧﯽ ﺋﻪو ﺑڕە ﻗﻪرزەی ﮐﻪ
            ﻟﻪ ﺋﻪﺳﺘۆﯾﻪﺗﯽ وە ﭘﺎﺑﻪﻧﺪ دەﺑێت ﺑﻪ دەرﺧﺴﺘﻨﯽ ﮔﺸﺖ ﭘﺴﻮوﻟﻪﮐﺎن ، ﺑﻪ
            ﭘێچەواﻧﻪوە ﺑﻪرﭘﺮﺳﯿﺎر دەﺑێت ﺑﻪراﻣﺒﻪر ﺑﻪ ﯾﺎﺳﺎ.
           </td>
          </tr>
         </tbody>
        </table>
       </div>
      </div>
     </div>
     <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br />
     <br />
     <br />
     <br />
     <div className="row">
      <div className="col-12">
       <table className="table">
        <tbody>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
           }}
          >
           32-
          </th>
          <td
           style={{
            lineHeight: "1.1",
            wordSpacing: "0px",
            color: "#000",

            fontSize: "22px",
            textAlign: "justify",
            borderTop: "none",
           }}
          >
           دوای ﮐۆﺗﺎﯾﯽ ﻫﺎﺗﻨﯽ ﻣﺎوەی ﺋﻪم گرێبەستە ﭘێوﯾﺴﺘﻪ ﻻﯾﻪﻧﯽ دووەم شوێنی
           ﺑﻪﮐﺮێگیراو ﭼۆڵ ﺑﮑﺎت وە رادەﺳﺘﯽ ﻻﯾﻪﻧﯽ ﯾﻪﮐﻪم ﺑﮑﺎﺗﻪوە وە ﺋﻪﮔﻪر ﻧﯿﺎزی ﻧﻮێ
           ﮐﺮدﻧﻪوەی ﮔﺮێبەﺳﺘﯽ ﻫﻪﺑێت ﺋﻪم گرێبەستە ﻧﻮێ دەکرێتەوە ﺑﻪ ﻧﺮﺧﯽ ڕۆژ ﺑﻪ
           رەزاﻣﻪﻧﺪی ﻫﻪردووﻻﯾﻪن وە ﺑﻪ ﻧاوەﻧﺪﮔﯿﺮی {name_krd} ﺳﻪﺑﺎرەت ﺑﻪ ﻧﺮخ داﻧﺎن
           و وە ﺑﻪ ﭼۆﻧﯿﻪﺗﯽ ﺷێوازی ﺑﻪﮐﺮێ ﺪان.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
           }}
          >
           33-
          </th>
          <td
           style={{
            lineHeight: "1.1",
            wordSpacing: "0px",
            color: "#000",

            fontSize: "22px",
            textAlign: "justify",
            borderTop: "none",
           }}
          >
           ﻟﻪ ﮐﺎﺗﯽ ﻧﻮێکردﻧﻪوەی ﮔﺮێبەﺳﺖ ﻫﻪر ﻻﯾﻪنێک ﭘﺎﺑﻪﻧﺪ دەﺑێت ﺑﻪ ﭘێداﻧﯽ ﮐﺮێی
           ﻧﯿﻮ ﻣﺎﻧﮓ ﺑۆ ﯾﻪک ﺳﺎڵ ﺑﻪ {name_krd}.
          </td>
         </tr>

         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
           }}
          >
           34-
          </th>
          <td
           style={{
            lineHeight: "1.1",
            wordSpacing: "0px",
            color: "#000",

            fontSize: "22px",
            textAlign: "justify",
            borderTop: "none",
           }}
          >
           ﻟﻪﺳﻪر ﻻﯾﻪﻧﯽ دووەم ﭘێوﯾﺴﺘﻪ ﻣﻮڵکەکەﮐﻪ ﺑۆ ﺋﻪو ﻣﻪﺑﻪﺳﺘﻪ ﺑﻪﮐﺎرﺑﻬێنێت ﮐﻪ
           ﻟﻪﺳﻪری رێککەوﺗﻮون ، وە بۆﮐﺎری ﻧﻪﺷﯿﺎو ﻧﺎﺷﻪرﻋﯽ و ﻧﺎﻗﺎﻧﻮﻧﯽ ﺑﻪﮐﺎرﻧﻪﻫێنرێت
           ، ﺑﻪ ﭘێچەواﻧﻪوە ﺑﻪرﭘﺮﺳﯿﺎر دەﺑﯿﺖ ﺑﻪراﻣﺒﻪر ﯾﺎﺳﺎ و ﮔﺮێبەﺳﺘﻪﮐﻪ
           ﻫﻪڵدەﺷێتەوە.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
           }}
          >
           35-
          </th>
          <td
           style={{
            lineHeight: "1.1",
            wordSpacing: "0px",
            color: "#000",

            fontSize: "22px",
            textAlign: "justify",
            borderTop: "none",
           }}
          >
           ﻻﯾﻪﻧﯽ دووەم ﺑﻪ ﻫﯿﭻ ﺷێوەیەﯾﻪک ﻧﺎﺑێت ﺑﺒێتە ﻣﺎﯾﻪی ﺋﻪزﯾﻪت و ﺋﺎزار ﺑۆ
           دراوﺳێیەﮐﺎﻧﯽ و ﺑﻪ ﭘێچەواﻧﻪوە ﺑﻪرﭘﺮﺳﯿﺎر دەﺑێت و ﮔﺮێبەﺳﺘﻪﮐﻪ
           ﻫﻪڵدەوەﺷێتەوە.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
           }}
          >
           36-
          </th>
          <td
           style={{
            lineHeight: "1.1",
            wordSpacing: "0px",
            color: "#000",

            fontSize: "22px",
            textAlign: "justify",
            borderTop: "none",
           }}
          >
           ﺑﻪﭘێی ﻣﺎددەی (17) ﺑﺮﮔﻪی (1) ﻟﻪﯾﺎﺳﺎی ﺑﻪﮐﺮێداﻧﯽ ﻋﯿﺮاﻗﯽ ژﻣﺎرە (87) ﺳﺎڵی
           1979 ز ، ﻧﺎﺑێت کرێچی ﮐﺮێی ﻣﺎﻧﮕﺎﻧﻪ دوا ﺑﺨﺎت زﯾﺎﺗﺮ ﻟﻪ (7) ﺣﻪوت رۆژ ﺑﻪ
           ﭘێچەواﻧﻪوە ﺑﻪرﭘﺮﺳﯿﺎر دەﺑێت ﺑﻪراﻣﺒﻪر ﺑﻪ ﯾﺎﺳﺎ ﺋﻪوﯾﺶ ﺑﻪ ﭼۆڵکردنی ﻣﻮڵکەﮐﻪ
           وە ﺗێچووی ﻫۆشداری دادﮔﺎ ﺋﻪﮐﻪوێتە ﺋﻪﺳﺘۆی ﻻﯾﻪﻧﯽ دووەم ﻟﻪﮔﻪل ﮐﺮێی
           ﻣﺎﻧﮕﺎﻧﻪ.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
           }}
          >
           37-
          </th>
          <td
           style={{
            lineHeight: "1.1",
            wordSpacing: "0px",
            color: "#000",

            fontSize: "22px",
            textAlign: "justify",
            borderTop: "none",
           }}
          >
           ﻟﻪﮐﺎﺗﯽ ﭼﺎرەﺳﻪر ﻧﻪﺑﻮوﻧﯽ ﮐێشەی ﻻﯾﻪﻧﯽ ﯾﻪﮐﻪم و دووەم ﺑﻪ ﺷێوازی ﮔﻔﺘﻮﮔۆ و
           داﻧﻮﺳﺘﺎﻧﺪن ﺋﻪوا {name_krd} ﺑﻪرﭘﺮس ﻧﯿﻪ وﻧﺎﺑێت ﺑﻪڵکو ﭘێوﯾﺴﺘﻪ ﻟﻪﺳﻪر
           ﻻﯾﻪﻧﻪﮐﺎن ﮐێشەکەﮐﻪ ﭼﺎرەﺳﻪر ﺑﮑﻪن ﺑﻪ ﮔﺮﺗﻨﻪﺑﻪری رێکاری ﯾﺎﺳﺎﯾﯽ ﺑﻪ ﭘﻪﻧﺎ
           ﺑﺮدن بۆ دادﮔﺎی ﺗﺎﯾﺒﻪﺗﻤﻪﻧﺪ.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
           }}
          >
           38-
          </th>
          <td
           style={{
            lineHeight: "1.1",
            wordSpacing: "0px",
            color: "#000",

            fontSize: "22px",
            textAlign: "justify",
            borderTop: "none",
           }}
          >
           ﺑڕگەﮐﺎﻧﯽ ﺋﻪم ﮔﺮێبەﺳﺘﻪ ﻟﻪژێر رۆﺷﻨﺎﯾﯽ ﯾﺎﺳﺎی ﺑﻪﮐﺮێداﻧﯽ ﻋێراﻗﯽ ژﻣﺎرە (87)
           ﺳﺎǏﯽ 1979 ز دارێژراوە ﺑﻪ ﭘﺎﺑﻪﻧﺪ ﻧﻪﺑﻮوﻧﯽ ﻫﻪرﻻﯾﻪﻧیک ﭘێی ﺑﻪرﭘﺮﺳﯿﺎر دەﺑێت
           ﺑﻪراﻣﺒﻪر ﺑﻪ ﯾﺎﺳﺎ.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
           }}
          >
           39-
          </th>
          <td
           style={{
            lineHeight: "1.1",
            wordSpacing: "0px",
            color: "#000",

            fontSize: "22px",
            textAlign: "justify",
            borderTop: "none",
           }}
          >
           ﺋﻪم گرێبەستە ﻟﻪ 39 ﺑﻪﻧﺪ ﭘێک دێت وە بە سێ ﮐۆﭘﯽ ﻧﻮوﺳﺮاوە وە کۆﭘﯿﯿﻪک ﻻی
           ﻫﻪر ﻻﯾﻪﻧێک دەﺑێت.
          </td>
         </tr>
        </tbody>
       </table>
      </div>
     </div>
     <div className="form-inline">
      <label
       style={{
        fontSize: "18px",
        color: "#000",
        fontWeight: "bold",
       }}
       className="form-label d-flex justify-content-start fkr"
      >
       {change_Lang("note")}&nbsp;:
      </label>
      &nbsp;
      <p
       style={{
        fontSize: "18px",
        color: "#000",
        fontWeight: "bold",
       }}
      >
       <div
        className="d-flex justify-content-start fkr"
        style={{ textAlign: "justify" }}
       >
        {rent_invoice_obj.note}
       </div>
      </p>
     </div>
     <br /> <br />
     <br />
     <br />
     <br />
     <br />
     <div className="row">
      <div className="form-group d-flex justify-content-center col-4">
       <label
        style={{
         fontSize: "20px",
         color: "#000",
         fontWeight: "bold",
        }}
        className="form-label"
       >
        لایەنی یەکەم (خاوەنی موڵك)
       </label>
      </div>
      <div className="col-4">
       <div className="form-group d-flex justify-content-center">
        <label
         style={{
          fontSize: "22px",
          color: "#000",
          fontWeight: "bold",
         }}
         className="form-label"
        >
         ڕێکخەری گرێبەست
        </label>
       </div>
      </div>
      <div className="col-4 d-flex justify-content-center">
       <div className="form-group ">
        <label
         style={{
          fontSize: "20px",
          color: "#000",
          fontWeight: "bold",
         }}
         className="form-label"
        >
         لایەنی دووەم (کرێچی)
        </label>
       </div>
      </div>
     </div>
     <div className="row">
      <div className="col-4 form-group d-flex justify-content-center">
       <label
        style={{
         fontSize: "20px",
         color: "#000",
        }}
        className="form-label"
       >
        {rent_invoice_obj.firstname}
       </label>
      </div>
      <div className="col-4">
       <div className="form-group d-flex justify-content-center">
        <label
         style={{
          fontSize: "20px",
          color: "#000",
         }}
         className="form-label"
        >
         {`${rent_invoice_obj.agentId && rent_invoice_obj.agentId.fname} ${
          rent_invoice_obj.agentId && rent_invoice_obj.agentId.lname
         }`}
        </label>
       </div>
      </div>
      <div className="col-4 d-flex justify-content-center">
       <div className="form-group ">
        <label
         style={{
          fontSize: "20px",
          color: "#000",
         }}
         className="form-label"
        >
         {rent_invoice_obj.tenantId && rent_invoice_obj.tenantId.secondname}
        </label>
       </div>
      </div>
     </div>
    </div>
   </>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  index_rentcontrct: state.Invoice_Reducer.index_rentcontrct,
  user: state.AuthReducer.user,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  thirdcolor: state.HelperReducer.thirdcolor,
  primary_logo: state.HelperReducer.primary_logo,
  footer_logo: state.HelperReducer.footer_logo,
  name_krd: state.HelperReducer.name_krd,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(RentPrintKurdish);
